import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import NoData from '@components/NoData';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { changeDateFormat, isPageReachBottom } from '@utils/Util';

const AdminList = ({ search, totalItems }) => {
	const [adminList, setAdminList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [page, setPage] = useState(0);
	const [size] = useState(15);
	const navigate = useNavigate();
	const filterData = useSelector((store) => store.filterFieldStore);
	const myStateRef = useRef();

	const getAdminList = async (size, filterData, search) => {
		let email = filterData?.email && filterData?.email[0]?.value ? filterData?.email[0]?.value : null;
		let roles =
			filterData?.roles && filterData.roles?.map((item) => item.key)
				? filterData.roles?.map((item) => item.key)
				: [];
		let departmentIdList =
			filterData?.departments && filterData.departments?.map((item) => item.key)
				? filterData.departments?.map((item) => item.key)
				: [];

		await setLoading(true);
		const params = {
			page: page,
			size: size,
			email: email,
			userLevelId: roles,
			departmentIdList: departmentIdList.join(','),
			name: search && search.length > 0 ? search : null,
			sort: 'id,desc'
		};

		await ApiClient.GET('getAdmins', params)
			.then(({ data }) => {
				setLoading(false);
				totalItems(`${data.totalElements} Admins`);
				if (page > 0) {
					data.data = [...myStateRef.current.data, ...data.data];
				}
				let tempAdmins = [...new Map(data.data.map((item) => [item.id, item])).values()];
				setAdminList(tempAdmins);
				myStateRef.current = data;
			})
			.catch((error) => {
				let response = error.response;
				setLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const handleScroll = () => {
		if (isPageReachBottom() && myStateRef && myStateRef.current) {
			let { totalElements, currentPage, data } = myStateRef.current;
			if (totalElements && totalElements > 0 && totalElements !== data.length) {
				setPage(currentPage + 1);
			}
		}
	};

	useEffect(() => {
		getAdminList(size, filterData, search);
	}, [filterData, page, search]);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	useEffect(() => {
		setPage(0);
	}, [search, filterData]);

	return (
		<LoaderComponent loading={loading}>
			<div className="admin-list-table admin-tab-table">
				<table className="table with-border">
					<thead>
						<tr>
							<th className="type-name">Admin Name</th>
							<th>Department</th>
							<th>Role</th>
							<th>Email</th>
							<th>Created by</th>
							<th>Status</th>
							<th>Action</th>
						</tr>
					</thead>
					<tbody>
						{adminList &&
							adminList.map((item, i) => (
								<tr key={i}>
									<td>{item.name}</td>
									<td>
										{item.departmentResponses
											.map((department) => department.name)
											.join(', ')}
									</td>
									<td>{item.userLevelName}</td>
									<td>{item.email}</td>
									<td>
										<p className="gray_dark_02">{item.createdBy?.name}</p>
										<p className="gray_dark_03">
											{changeDateFormat(item.createdAt, 'YYYY-MM-DD', 'DD MMM, YYYY')}
										</p>
									</td>
									<td>
										{item.status === 'ACTIVE' ? (
											<div className="task-status green">
												<span className="status-btn ">Active</span>
											</div>
										) : (
											<div className="task-status red">
												<span className="status-btn ">Disabled</span>
											</div>
										)}
									</td>
									<td>
										<span
											className="font-weight-normal text-black cursor-pointer"
											onClick={() => navigate('/admins/edit/' + item.id)}
										>
											Edit
										</span>
									</td>
								</tr>
							))}
					</tbody>
				</table>
				{adminList.length === 0 && <NoData message={'No result found'} />}

				<Modal
					show={showDeleteModal}
					onHide={() => setShowDeleteModal(false)}
					dialogClassName="modal-90w role-modal"
					aria-labelledby="example-custom-modal-styling-title"
				>
					<Modal.Header closeButton>
						<Modal.Title id="example-custom-modal-styling-title">Delete role</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="container">
							<div className="section-content">
								<br />
								<br />
								<div className="form-row role-delete-modalbox">
									<div className="">
										<button
											type="submit"
											className="button tertiary size32"
											// onClick={() => onDeleteRole()}
										>
											Confirm
										</button>
									</div>
									<div className="ml-2">
										<button
											type="submit"
											className="button gray-outline size32"
											onClick={() => setShowDeleteModal(false)}
										>
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		</LoaderComponent>
	);
};

export default AdminList;
